import React from 'react';
import classNames from 'classnames';
import CellValue from '@app/shared/components/cell-value/CellValue';
import { Alignment } from '@app/shared/enums/alignment.enum';
import GridTextField from '@app/shared/components/grid-controls/grid-text-field/GridTextField';
import { numericBaseFieldFormattingProps } from '@app/shared/components/form-controls/form-field/form-field-patterns';
import { positiveOrNullValidator } from '@app/core/validations/hook-forms/validators';
import styles from './dividends-table.module.scss';
import useGetHistoricDividendYears from '@app/shared/hooks/useGetHistoricDividendYears';
import { DividendInstrumentDto } from '@app/shared/models/contracts/project-dto';

interface HistoricCellsProps {
  instrumentId: string;
  isEligible: boolean;
  historicDividendInstruments: Record<string, DividendInstrumentDto>;
  instrumentCreationDates: { instrumentId: string; creationDate: string }[];
}

const HistoricCells: React.FC<HistoricCellsProps> = ({
  instrumentId,
  isEligible,
  historicDividendInstruments,
  instrumentCreationDates,
}) => {
  const dates = useGetHistoricDividendYears();
  const instrumentCreationDate = new Date(
    instrumentCreationDates.find((i) => i.instrumentId === instrumentId)?.creationDate ?? ''
  );

  return (
    <>
      {dates.map((date, idx) => {
        const key = `${instrumentId}-historic-${date}`;
        if (!historicDividendInstruments[instrumentId] || new Date(date) < instrumentCreationDate) {
          return <td key={`${instrumentId}-forecast-empty-${idx}`} />;
        }
        if (isEligible) {
          return (
            <td key={key}>
              <GridTextField
                name={`historicDividendInstruments[${instrumentId}].dates[${date}].totalDividendValue`}
                alignment={Alignment.Right}
                placeholder="0"
                {...numericBaseFieldFormattingProps}
                rules={{ ...positiveOrNullValidator(true) }}
              />
            </td>
          );
        }
        return (
          <td key={key} className={classNames(styles['ineligible-value'])}>
            <CellValue
              value={historicDividendInstruments[instrumentId].dates[date].totalDividendValue}
              normalize
              alignment={Alignment.Right}
              allowEmptyValues
            />
          </td>
        );
      })}
    </>
  );
};

export default HistoricCells;
